var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('div',{attrs:{"id":"content-wrap"}},[_vm._m(0),_c('div',[_c('div',{staticStyle:{"height":"100%"}},[_c('iframe',{attrs:{"title":"dashboard","frameborder":"0","width":"100%","height":"2000px","src":_vm.getDashboardEmbedCode()}})])])])])
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',[_c('title',[_vm._v(" Analytics ")])])
}]

export { render, staticRenderFns }